import React, { useState } from 'react';

import Modal from '@material-ui/core/Modal';
import { Grid, Backdrop } from '@mui/material';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { Register, Login } from 'src/App/Dashboards/Market/Pages';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    authModal: {
      position: 'fixed',
      bottom: '50%',
      left: '50%',
      transform: 'translate(-50%, 50%)',
      [theme.breakpoints.up('xs')]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      },
      [theme.breakpoints.up('sm')]: {
        width: 530,
        maxHeight: 'min(800px, 95vh)',
        borderRadius: 10,
      },
      [theme.breakpoints.up('lg')]: {
        width: 650,
        maxHeight: 'min(800px, 95vh)',
        borderRadius: 10,
      },
      overflow: 'auto',
      backgroundColor: 'white',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    onboardingModal: {
      position: 'relative',
      width: '100%',
      animation: 'fade-scale-in 0.3s ease forwards',
    },
  })
);

const AuthModal = ({
  authModalOpen,
  setAuthModalOpen,
  getUserInfo,
  getTokenThunk,
  matches,
  landing,
}) => {
  const classes = useStyles();
  const isLoggedIn = Boolean(getTokenThunk());
  const search_attempt_history = localStorage.getItem('investment-search-attempts');
  const noOfUserSearch = search_attempt_history ? parseInt(search_attempt_history) : 0;
  const isEstimator = window.location.pathname.includes('/airbnb-calculator');

  const [signupPage, setSignupPage] = useState(true);

  const redirectToLoginPage = () => {
    setSignupPage(false);
  };

  const redirectToSignupPage = () => {
    setSignupPage(true);
  };

  return (
    <Modal
      open={authModalOpen}
      onClose={() => {
        !isEstimator && noOfUserSearch < 4 && setAuthModalOpen(false);
      }}
      aria-labelledby="auth-modal"
      aria-describedby="auth-modal-description"
      BackdropComponent={Backdrop}
    >
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          height: '100vh',
          paddingBottom: 'env(safe-area-inset-bottom)',
          paddingTop: 'env(safe-area-inset-top)',
        }}
      >
        <div className={`${classes.authModal} modal-custom`}>
          {signupPage ? (
            <Register
              redirectToLoginPage={redirectToLoginPage}
              getUserInfo={getUserInfo}
              landing={landing}
              device={matches ? 'mobile' : 'desktop'}
            />
          ) : (
            <Login
              redirectToSignupPage={redirectToSignupPage}
              landing={landing}
              device={matches ? 'mobile' : 'desktop'}
            />
          )}
        </div>
      </Grid>
    </Modal>
  );
};

export default AuthModal;
